import { render, staticRenderFns } from "./childrenPolicyPublicityDialogClassify.vue?vue&type=template&id=2221e3c4&scoped=true&"
import script from "./childrenPolicyPublicityDialogClassify.vue?vue&type=script&lang=js&"
export * from "./childrenPolicyPublicityDialogClassify.vue?vue&type=script&lang=js&"
import style0 from "./childrenPolicyPublicityDialogClassify.vue?vue&type=style&index=0&id=2221e3c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2221e3c4",
  null
  
)

export default component.exports